import React from 'react';
import styles from './index.modules.scss';
import { Text, Tip } from '@shakkerai/pro-components';

export const Descriptions = (props) => {
  const { children, ...rest } = props;
  return (
    <div className={styles.descriptions} {...rest}>
      {children}
    </div>
  );
};

export const DescriptionsItem = (props) => {
  const { label, children } = props;

  return (
    <div className={styles.descriptionsItem}>
      <Tip
        style={{
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          marginRight: '10px',
        }}
      >
        {label}
      </Tip>
      <Text
        size={12}
        color="#2c2c2c"
        style={{
          textOverflow: 'ellipsis',
          userSelect: 'text',
        }}
      >
        {children}
      </Text>
    </div>
  );
};
